export enum PropertyUtilitiesPriceTypeEnum {
  inclusive = 'inclusive',
  exclusive = 'exclusive',
  notSelected = '',
}
